import uploadFile from '../../util/upload';
import { combineSidesToSinglePdf } from './combineDocumentSides.js';

const optsFor = (blob, type, context, allowedTypes, filename) => ({
	contentType: blob.type || 'application/octet-stream',
	type,
	filename: filename || type,
	context,
	allowedDocumentTypes: allowedTypes,
});

// One logical document = one delivery: a passport's single side (or a pre-combined `both`) is sent
// as-is; a two-sided doc's front+back are combined into ONE PDF (front = page 1, back = page 2).
export async function uploadDocument({ type, sides, context, allowedTypes, uploadUrl }) {
	if (sides.both) {
		return uploadFile(uploadUrl, sides.both, false, optsFor(sides.both, type, context, allowedTypes));
	}
	if (sides.single) {
		const pp = sides.single;
		return uploadFile(uploadUrl, pp, false, optsFor(pp, type, context, allowedTypes));
	}
	if (sides.back) {
		const pdf = await combineSidesToSinglePdf([sides.front, sides.back]);
		return uploadFile(uploadUrl, pdf, false, optsFor(pdf, type, context, allowedTypes, `${type}.pdf`));
	}
	return uploadFile(uploadUrl, sides.front, false, optsFor(sides.front, type, context, allowedTypes));
}
